import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilService } from '@services/util/util.service';
import { VariablesService } from '@services/variables/variables.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home-v2-dock',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './home-v2-dock.component.html',
  styleUrls: ['./home-v2-dock.component.scss']
})
export class HomeV2DockComponent {

  private utilService = inject(UtilService);
  private vars = inject(VariablesService);
  private router = inject(Router);
  dockList = [
    {id: 1, iconName: 'home-dock', label: 'Home', redirectTo: '', isNew: false },
    {id: 1, iconName: 'search-dock', label: 'Explore', redirectTo: '/crowdfunding/fundraisers', isNew: false },
    {id: 1, iconName: 'profile', label: 'Profile', redirectTo: '', isNew: false}
  ];

  userData;

  ngOnInit() {
    this.userData = this.utilService.getUserData();
  }

  onRedirectionClicked(item) {
    if (this.utilService.isBrowser && item.iconName !== 'home-dock') {
      if (item.iconName === 'profile') {
        this.vars.openDrawerFromDockState.next('open');
        return;
      }
      if (item.iconName === 'home-dock') {
        return;
      }
      this.router.navigate([item.redirectTo]);
    }
  }
}
